/**
 * @file src/assets/images/index.js
 * @description Barrel export cho toàn bộ image assets của dự án.
 * Các import được nhóm theo thư mục con tương ứng.
 *
 * Cách sử dụng:
 *   import images from '@assets/images'
 *   images.logo | images.iconClose | ...
 */

// Logo — served from /public/ for stable URL → preloadable in index.html
const logo = `${import.meta.env.BASE_URL}logo.png`;

// ─────────────────────────────────────────────────────────────
// Icons
// ─────────────────────────────────────────────────────────────
import icon360 from "./icon/360.svg";
import iconClose from "./icon/close.svg";
import iconExpand from "./icon/expand.svg";
import iconFullscreen from "./icon/fullscreen.svg";
import iconMinus from "./icon/minus.svg";
import iconMusic from "./icon/music.svg";
import iconPlay from "./icon/play.png";
import iconPlus from "./icon/plus.svg";
import iconToggle from "./icon/toggle.svg";

// ─────────────────────────────────────────────────────────────
// Brochure
// ─────────────────────────────────────────────────────────────
import brochure1 from "./brochure/1.webp";
import brochure2 from "./brochure/2.webp";
import brochure3 from "./brochure/3.webp";
import brochure4 from "./brochure/4.webp";
import brochure5 from "./brochure/5.webp";
import brochure6 from "./brochure/6.webp";
import brochure7 from "./brochure/7.webp";
import brochure8 from "./brochure/8.webp";
import brochure9 from "./brochure/9.webp";
import brochure10 from "./brochure/10.webp";
import brochure11 from "./brochure/11.webp";
import brochure12 from "./brochure/12.webp";
import brochure13 from "./brochure/13.webp";
import brochure14 from "./brochure/14.webp";
import brochure15 from "./brochure/15.webp";
import brochure16 from "./brochure/16.webp";
import brochure17 from "./brochure/17.webp";
import brochure18 from "./brochure/18.webp";
import brochure19 from "./brochure/19.webp";
import brochure20 from "./brochure/20.webp";
import brochure21 from "./brochure/21.webp";
import brochure22 from "./brochure/22.webp";
import brochure23 from "./brochure/23.webp";
import brochure24 from "./brochure/24.webp";
import brochure25 from "./brochure/25.webp";
import brochure26 from "./brochure/26.webp";
import brochure27 from "./brochure/27.webp";
import brochure28 from "./brochure/28.webp";
import brochure29 from "./brochure/29.webp";
import brochure30 from "./brochure/30.webp";
import brochure31 from "./brochure/31.webp";
import brochure32 from "./brochure/32.webp";
import brochure33 from "./brochure/33.webp";
import brochure34 from "./brochure/34.webp";
import brochure35 from "./brochure/35.webp";
import brochure36 from "./brochure/36.webp";
import brochure37 from "./brochure/37.webp";

// ─────────────────────────────────────────────────────────────
// Gallery
// (Thêm ảnh vào thư mục gallery/ và import tại đây)
// ─────────────────────────────────────────────────────────────

// ─────────────────────────────────────────────────────────────
// Plan (Mặt bằng)
// ─────────────────────────────────────────────────────────────

import plan3_7 from "./plan/Tầng 3-7.png";
import plan8_12A from "./plan/Tầng 8-12A.png";
import plan14_21 from "./plan/Tầng 14-21.png";
import plan22 from "./plan/Tầng 22.png";

// ─────────────────────────────────────────────────────────────
// Mobile Plan images (per block)
// ─────────────────────────────────────────────────────────────
import mobilePlan_3_7_A   from "./plan/mobile/plan/plan-3-7-A.png";
import mobilePlan_3_7_B   from "./plan/mobile/plan/plan-3-7-B.png";
import mobilePlan_8_12_B  from "./plan/mobile/plan/plan-8-12-B.png";
import mobilePlan_14_21_A from "./plan/mobile/plan/plan-14-21-A.png";
import mobilePlan_14_21_B from "./plan/mobile/plan/plan-14-21-B.png";
import mobilePlan_22_B    from "./plan/mobile/plan/plan-22-B.png";

// Mobile Utility images (directions + la bàn + legend)
import utilFaLeft   from "./plan/mobile/utility/fa_left.webp";
import utilGaBottom from "./plan/mobile/utility/ga_bottom.webp";
import utilKdlRight from "./plan/mobile/utility/kdl_right.webp";
import utilKdlTop   from "./plan/mobile/utility/kdl_top.webp";
import utilLaban    from "./plan/mobile/utility/laban.webp";
import utilType1PN  from "./plan/mobile/utility/1pn.webp";
import utilType1PN1 from "./plan/mobile/utility/1pn_1.webp";
import utilType2PN  from "./plan/mobile/utility/2pn.webp";
import utilType3PN  from "./plan/mobile/utility/3pn.webp";

// ─────────────────────────────────────────────────────────────
// Bedrooms (Loại căn mặt bằng)
// ─────────────────────────────────────────────────────────────
import bedroom1PN from "./plan/bedrooms/1PN.webp";
import bedroom1PNPlus from "./plan/bedrooms/1PN+1.webp";
import bedroom1PNGoc from "./plan/bedrooms/1PN_GOC.webp";
import bedroom2PN from "./plan/bedrooms/2PN.webp";
import bedroom2PN2 from "./plan/bedrooms/2PN_2.webp";
import bedroom3PN from "./plan/bedrooms/3PN.webp";

// ─────────────────────────────────────────────────────────────
// Loading — served from /public/ so the browser can preload it
// before React mounts (see <link rel="preload"> in index.html)
// ─────────────────────────────────────────────────────────────
const loadingImg = `${import.meta.env.BASE_URL}loading.webp`;

// ─────────────────────────────────────────────────────────────
// Exports
// ─────────────────────────────────────────────────────────────
const images = {
  // Logo
  logo,

  // Icons
  icon360,
  iconClose,
  iconExpand,
  iconFullscreen,
  iconMinus,
  iconMusic,
  iconPlay,
  iconPlus,
  iconToggle,

  // Plan (desktop)
  plan3_7,
  plan8_12A,
  plan14_21,
  plan22,

  // Mobile Plan (per block)
  mobilePlan_3_7_A,
  mobilePlan_3_7_B,
  mobilePlan_8_12_B,
  mobilePlan_14_21_A,
  mobilePlan_14_21_B,
  mobilePlan_22_B,

  // Mobile Utility
  utilFaLeft,
  utilGaBottom,
  utilKdlRight,
  utilKdlTop,
  utilLaban,
  utilType1PN,
  utilType1PN1,
  utilType2PN,
  utilType3PN,

  // Bedrooms
  bedroom1PN,
  bedroom1PNPlus,
  bedroom1PNGoc,
  bedroom2PN,
  bedroom2PN2,
  bedroom3PN,

  // Brochure
  brochure1,
  brochure2,
  brochure3,
  brochure4,
  brochure5,
  brochure6,
  brochure7,
  brochure8,
  brochure9,
  brochure10,
  brochure11,
  brochure12,
  brochure13,
  brochure14,
  brochure15,
  brochure16,
  brochure17,
  brochure18,
  brochure19,
  brochure20,
  brochure21,
  brochure22,
  brochure23,
  brochure24,
  brochure25,
  brochure26,
  brochure27,
  brochure28,
  brochure29,
  brochure30,
  brochure31,
  brochure32,
  brochure33,
  brochure34,
  brochure35,
  brochure36,
  brochure37,

  // Loading
  loadingImg,
};

export default images;
